// @react-native-documents/picker stub for web
const DocumentPicker = {
  pick: async (_options?: any) => {
    return new Promise((resolve, reject) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.onchange = (e: any) => {
        const file = e.target?.files?.[0];
        if (file) {
          resolve([{uri: URL.createObjectURL(file), name: file.name, type: file.type, size: file.size}]);
        } else {
          reject(new Error('No file selected'));
        }
      };
      input.click();
    });
  },
  isCancel: (err: any) => err?.message === 'No file selected',
};

export default DocumentPicker;
